<script setup lang="ts">
import { useAuthStore } from '~/store/authStore'

const authStore = useAuthStore()
const user = await authStore.getUser()
const localePath = useLocalePath()
</script>

<template>
  <UiSheet>
    <UiSheetTrigger as-child>
      <UiButton
        :variant="user !== null ? 'outline' : 'default'"
        class="relative overflow-hidden"
      >
        <UiChip
          :show="user !== null && authStore.getUnreadNotificationsCount > 0"
          class="bg-red-500 text-white ring-0"
          size="lg"
          :text="authStore.getUnreadNotificationsCount.toString()"
        >
          <Icon name="tabler:user" />
        </UiChip>
        <div class="max-w-20 truncate">
          {{ user?.name ?? 'Login' }}
        </div>
        <UiBadge
          v-if="authStore.isImpersonating()"
          floating
          color="negative"
        >
          IMP
        </UiBadge>
      </UiButton>
    </UiSheetTrigger>
    <UiSheetContent class="w-full sm:w-96 overflow-auto">
      <UiSheetHeader>
        <UiSheetTitle>
          {{ user ? $t('Welcome back, {name}', { name: user.name }) : $t('Login') }}
        </UiSheetTitle>
        <UiSheetDescription>
          {{ user ? $t('Manage your account and settings') : $t('Create an account to get started') }}
        </UiSheetDescription>
      </UiSheetHeader>
      <div v-if="authStore.isImpersonating()">
        <UiButton
          icon="tabler:logout"
          class="w-full"
          @click="authStore.unimpersonate()"
        >
          {{ $t('UnImpersonate') }}
        </UiButton>
      </div>
      <div
        v-if="user"
        class="flex flex-col gap-2"
      >
        <div
          class="flex flex-row justify-evenly gap-2 mt-2"
        >
          <UiSheetClose as-child>
            <UiButton
              icon="tabler:settings"
              class="w-full"
              :to="localePath('/profile/settings')"
            >
              {{ $t('Settings') }}
            </UiButton>
          </UiSheetClose>
          <UiSheetClose as-child>
            <UiButton
              icon="tabler:logout"
              class="w-full"
              @click="authStore.logUserOut()"
            >
              {{ $t('Sign out') }}
            </UiButton>
          </UiSheetClose>
        </div>
        <NotificationsContent />
      </div>
      <div
        v-else
        class="flex flex-row justify-evenly gap-2 mt-2"
      >
        <UiSheetClose as-child>
          <UiButton
            icon="tabler:login"
            class="w-full"
            :to="localePath('/auth/login')"
          >
            {{ $t('Login') }}
          </UiButton>
        </UiSheetClose>
        <UiSheetClose as-child>
          <UiButton
            icon="tabler:user-plus"
            class="w-full"
            :to="localePath('/auth/register')"
          >
            {{ $t('Create account') }}
          </UiButton>
        </UiSheetClose>
      </div>
    </UiSheetContent>
  </UiSheet>
</template>
